import { FutureRosters } from './FutureRosters';
import { TodaysRoster } from './TodaysRoster';

export const RosterSection = () => {
  return (
    <div className="flex flex-col gap-5 w-full">
      <TodaysRoster />
      <FutureRosters />
    </div>
  );
};
